export enum IncidentClass {
  BuildingFault = 'Gebäudestörung',
  OptionalServices = 'Optionale Leistungen',
  BasicServiceChange = 'Änderung Basisleistungen',
  FurnitureOrder = 'Büromöbelbestellung',
  Relocation = 'Umzug',
  AreaRequest = 'Flächenanfrage',
  AreaReturn = 'Flächenrückgabe',
  UserAdministration = 'Benutzeradministration',
  UserCreation = 'Benutzeranlage',
  RoleRequest = 'Berechtigungsanfrage',
  RoleRemoval = 'Berechtigungsentzug',
}
